import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { consultationOfflineStore, OfflinePatient } from '@/core/offline'

export function useStartLocalConsultation() {
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const [isStartingConsultation, setIsStartingConsultation] = useState(false)

  const startLocalConsultation = useCallback(async (patient: OfflinePatient) => {
    try {
      setIsStartingConsultation(true)

      // Create offline consultation
      const consultation = await consultationOfflineStore.createOfflineConsultation(patient)

      enqueueSnackbar(t('notification.localConsultation.create.success'), { variant: 'success' })

      // Navigate to the offline local consultation page
      navigate(`/offline/consultations/${consultation._id}`)
    } catch (error) {
      console.error('Error starting offline consultation:', error)
      enqueueSnackbar(t('notification.consultation.create.error'), { variant: 'error' })
    } finally {
      setIsStartingConsultation(false)
    }
  }, [])

  return [startLocalConsultation, isStartingConsultation] as const
}
